import React, { ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { usePrefillableValue } from '../../hooks/usePrefillableValue';
import { HintTextboxViewModel } from '../../types/hintTextbox';
import JabraInput from '../Shared/JabraInput';
import { RichLabelProps } from '../Shared/JabraLabel';

const HintTextbox: React.FC<ValueFieldProps<HintTextboxViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const { hintText, placeholderText, required } = field.model;
  const [value, setValue] = usePrefillableValue(
    field.model.name,
    props.value,
    props.onChange,
    field.valueField.name
  );
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent as React.FC<RichLabelProps>;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      {!!Label && <Label richTitle={hintText} {...props} />}
      <JabraInput
        type="text"
        id={id}
        name={name}
        value={value}
        jssMetadata={props}
        placeholder={placeholderText}
        required={required}
        onChange={onChange}
      />
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default HintTextbox;
